import styled from 'styled-components';

export const StyledInteriorContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;
